<template>
    <div>
        <div v-if="showModal" class="overlay" @click="closeModal"></div>

        <div v-if="showModal" class="modal w-[85%] overflow-scroll lg:w-[65%] lg:overflow-hidden lg:p-[50px]">
            <div class="centerbox relative flex flex-col gap-[30px]">
                <div class="top flex flex-col space-y-2 px-[15px] py-[20px] lg:h-[45%] lg:flex-row">
                    <div class="left mb-4 lg:mb-0 lg:h-[70%] lg:w-[55%]">
                        <h3 class="w-full text-[18px] lg:w-[80%] lg:text-[18px]">Run Microsoft Office and Google Workspace</h3>
                        <p class="w-full text-[15px] lg:w-[80%] lg:text-[14px]">
                            NearHubOS supports Google Workspace apps, so you can open, edit, and auto-save Google Docs, Slides, Sheets, and more. NearHubOS also supports Office 365 apps. Users can directly access and edit Office files through the Chrome browser, or install the Microsoft Office
                            Android Mobile Version on their NearHub Board for more touchscreen capabilities.
                        </p>
                    </div>
                    <div class="right1 lg:h-[20%] lg:w-[35%]">
                        <img :src="`${ossPath}/shop/s55/Group2638(1).png`" alt="" />
                    </div>
                </div>
                <div class="bottom flex flex-col space-y-2 px-[15px] py-[20px] lg:h-[45%] lg:flex-row">
                    <div class="left mb-4 lg:mb-0 lg:h-[70%] lg:w-[55%]">
                        <h3 class="w-full text-[18px] lg:w-[80%] lg:text-[18px]">Work with Loved Apps from Google Play and NearHub App Store</h3>
                        <p class="w-full text-[15px] lg:w-[80%] lg:text-[14px]">
                            NearHubOS seamlessly integrates Android 11 runtime, enabling full support for the Google Play Store and your favorite touchscreen-friendly apps. That means easy, fast adoption throughout organizations with minimal support from busy IT teams.
                        </p>
                    </div>
                    <div class="right2 lg:h-[20%] lg:w-[35%]">
                        <img :src="`${ossPath}/shop/s55/Group2468(1).png`" alt="" />
                    </div>
                </div>
            </div>
            <!-- <button @click="closeModal">
                <img :src="`${ossPath}/shop/s55/Group2634(1).png`" alt="" />
            </button> -->
            <button class="dasiy-btn-ghost dasiy-btn-sm dasiy-btn-circle dasiy-btn absolute right-2 top-2" @click="closeModal">X</button>
        </div>
    </div>
</template>

<script setup>
import { ref } from "vue";
const showModal = ref(false);
const open = () => {
    showModal.value = true;
};
defineExpose({
    open,
});

const closeModal = () => {
    showModal.value = false;
};
</script>

<style scoped>
.overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 9998;
}

.modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: white;
    z-index: 9999;
    border-radius: 22px;
    max-height: 90%;
}

.top {
    display: flex;
    justify-content: space-around;
    align-items: center;
    background-color: #f8f8f8;
    margin: 0 auto;
    border-radius: 12px;
}

.bottom {
    display: flex;
    justify-content: space-around;
    align-items: center;
    background-color: #f8f8f8;
    border-radius: 12px;
    margin: 0 auto;
}

h3 {
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;
    margin-bottom: 20px;
}
p {
    font-weight: 400;
    line-height: 23px;
    letter-spacing: 0em;
    text-align: left;
}
button {
    position: absolute;
    top: 10px;
    right: 5px;
    img {
        width: 40px;
        height: 40px;
    }
}

@media screen and (max-width: 768px) {
  .modal {
    border-radius: 8px;
  }
  h3 {
    line-height: 24px;
    margin-bottom: 10px;
  }
  
  p {
    font-size: 12px;
  }
}
</style>
